import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Card, Button, Container } from 'react-bootstrap';
import Header from '../components/Layout/Header';

const PaymentSuccessPage = () => {
  const location = useLocation();
  const { orderId, paymentIntentId, amount } = location.state || {};

  return (
    <>
      <Header />
      <Container className="d-flex align-items-center justify-content-center min-vh-100">
        <Card className="text-center shadow" style={{ maxWidth: '600px', width: '100%' }}>
          <Card.Body className="p-5">
            <div className="mb-4">
              <div className="text-success mb-3" style={{ fontSize: '80px' }}>
                ✓
              </div>
              <h2 className="mb-3 text-success">Paiement réussi !</h2>
              <p className="text-muted mb-4">
                Votre paiement a été traité avec succès et votre commande a été confirmée.
              </p>

              {amount && (
                <div className="bg-light p-3 rounded mb-4">
                  <div className="d-flex justify-content-between mb-2">
                    <span className="text-muted">Montant payé:</span>
                    <strong className="h5 text-success mb-0">{amount.toFixed(2)} €</strong>
                  </div>
                  {orderId && (
                    <div className="d-flex justify-content-between">
                      <span className="text-muted">Numéro de commande:</span>
                      <strong>#{orderId}</strong>
                    </div>
                  )}
                  {paymentIntentId && (
                    <div className="d-flex justify-content-between mt-1">
                      <span className="text-muted small">ID de transaction:</span>
                      <span className="small text-muted">{paymentIntentId.substring(0, 20)}...</span>
                    </div>
                  )}
                </div>
              )}

              <div className="alert alert-info">
                <strong>Que se passe-t-il maintenant ?</strong>
                <p className="mb-0 mt-2">
                  Vous recevrez un email de confirmation avec les détails de votre commande.
                  Notre équipe vous contactera pour organiser la livraison.
                </p>
              </div>
            </div>

            <div className="d-grid gap-2">
              <Link to="/commande">
                <Button variant="primary" size="lg" className="w-100">
                  Nouvelle commande
                </Button>
              </Link>
              <Link to="/historique">
                <Button variant="outline-secondary" size="lg" className="w-100">
                  Voir l'historique
                </Button>
              </Link>
              <Link to="/">
                <Button variant="link" className="w-100">
                  Retour à l'accueil
                </Button>
              </Link>
            </div>
          </Card.Body>
        </Card>
      </Container>
    </>
  );
};

export default PaymentSuccessPage;
